<template>
  <el-dialog
    title="填写通过备注"
    :visible.sync="visible"
    width="30%"
    top="15%"
    @close="close"
  >
    <el-input
      type="textarea"
      :rows="5"
      placeholder="请填写通过备注（选填）"
      v-model="suggest"
      maxlength="100"
    >
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" class="w100f" @click="handleSubmit"
        >通过</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "PassQuestionnaireReviewDialog",
  data() {
    return {
      suggest: "",
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.suggest = "";
    },
    close() {
      this.visible = false;
      this.suggest = "";
    },
    handleSubmit() {
      this.$emit("submit", this.suggest);
    },
  },
};
</script>

<style scoped>
.w100f {
  width: 100%;
}
</style>
